import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ExpertBox from "../../components/path/expertBox";
import { profileClient } from "../../network/lib/profile";
import { Icon } from "@iconify/react";

function NosExperts() {
  const { officeName, profileUrl } = useParams();

  const [expertListData, expertListDataSet] = useState([]);
  const [listTypeData, listTypeDataSet] = useState("ALL");

  useEffect(() => {
    fetchExperts(listTypeData);

    const intervalId = setInterval(() => {
      fetchExperts(listTypeData);
    }, 5000);

    return () => clearInterval(intervalId);
  }, [listTypeData]); // Adding listTypeData as dependency

  const fetchExperts = (expertType) => {
    listTypeDataSet(expertType);
    profileClient.expert
      .getByCategory(expertType, officeName)
      .then((res) => expertListDataSet(res.data.experts));
  };

  return (
    <div className="modern-page">
      <div className="page-header">
        <h1 className="page-title">Nos Experts</h1>
        <p className="page-description">Découvrez nos spécialistes et choisissez celui qui vous correspond le mieux</p>
      </div>

      <div className="page-content">
        <div className="modern-card">
          <div className="card-header">
            <h3 className="card-title">Filtrer par spécialité</h3>
            <p className="experts-count">
              {expertListData.length} expert{expertListData.length > 1 ? 's' : ''} disponible{expertListData.length > 1 ? 's' : ''}
            </p>
          </div>
          <div className="card-body">
            <div className="modern-tags">
              <span 
                className={`tag ${listTypeData === "ALL" ? "active" : ""}`}
                onClick={() => fetchExperts("ALL")}
              >
                Tous
              </span>
              <span 
                className={`tag ${listTypeData === "TAROLOGUES" ? "active" : ""}`}
                onClick={() => fetchExperts("TAROLOGUES")}
              >
                Tarologues
              </span>
              <span 
                className={`tag ${listTypeData === "MEDIUMS" ? "active" : ""}`}
                onClick={() => fetchExperts("MEDIUMS")}
              >
                Médiums
              </span>
              <span 
                className={`tag ${listTypeData === "VOYANTS" ? "active" : ""}`}
                onClick={() => fetchExperts("VOYANTS")}
              >
                Voyants
              </span>
              <span 
                className={`tag ${listTypeData === "ASTROLOGUES" ? "active" : ""}`}
                onClick={() => fetchExperts("ASTROLOGUES")}
              >
                Astrologues
              </span>
              <span 
                className={`tag ${listTypeData === "RADIESTHESISTES" ? "active" : ""}`}
                onClick={() => fetchExperts("RADIESTHESISTES")}
              >
                Radiesthésistes
              </span>
              <span 
                className={`tag ${listTypeData === "NUMEROLOGUES" ? "active" : ""}`}
                onClick={() => fetchExperts("NUMEROLOGUES")}
              >
                Numérologues
              </span>
              <span 
                className={`tag ${listTypeData === "CARTOMANCIENS" ? "active" : ""}`}
                onClick={() => fetchExperts("CARTOMANCIENS")}
              >
                Cartomanciens
              </span>
            </div>
          </div>
        </div>

        <div className="experts-grid">
          {expertListData.length > 0 ? (
            <div className="modern-grid grid-4">
              {expertListData.map((expert, index) => {
                return (
                  <ExpertBox
                    key={index}
                    id={expert["id"]}
                    officeName={officeName}
                    name={expert["name"]}
                    call={expert["callCount"]}
                    category={expert["category"]}
                    description={expert["description"]}
                    advice={expert["adviceStar"]}
                    disponibily={expert["statue"]}
                    benefits={expert["benefits"]}
                    imageProfile={expert["imageProfile"]}
                    imageBanner={expert["imageBanner"]}
                    profileUrl={profileUrl}
                    isWebhook={true}
                  />
                );
              })}
            </div>
          ) : (
            <div className="empty-state">
              <div className="empty-state-content">
                <Icon icon="ic:baseline-person-off" className="empty-icon" />
                <h3>Aucun expert disponible</h3>
                <p>Essayez de sélectionner une autre catégorie</p>
              </div>
            </div>
          )}
        </div>
      </div>

      <footer className="modern-footer">
        <div className="footer-content">
          <p>
            A service provided by <a href="https://vooxhub.com" target="_blank" rel="noopener noreferrer">VooxHub</a> - 2023 © All rights reserved
          </p>
          <p>
            Developed by <a href="https://shield4Cloud.com" target="_blank" rel="noopener noreferrer">Shield4Cloud</a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default NosExperts;
